import { IconButton } from "@chakra-ui/react"
import React from "react";
import { Context } from "../App";
import Icon, { Icons } from "./Icons";
import { Language } from "../generic/Translations";


export const LanguageSwitcher = () => {
    const { language, setLanguage } = React.useContext(Context);
    const languageFromLocalStorage = typeof window !== "undefined" ? localStorage.getItem("language") : null;

    React.useEffect(() => {
        if (languageFromLocalStorage) {
            setLanguage(languageFromLocalStorage as Language);
        }
    }, [languageFromLocalStorage, setLanguage]);

    return (
        <IconButton
            variant="ghost"
            fontSize="2xl"
            marginLeft="2"
            onClick={() => setLanguage(language === Language.EN ? Language.SE : Language.EN)}
            aria-label={`Switch to ${language} mode`}
        >
            <Icon icon={Icons.Language} />
        </IconButton>
    )
}